var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineLampSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65 18.86a.754.754 0 0 1 0-1.06L19.5 1.95c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L4.71 18.86c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56 13.3c-.49-1.12-.74-2.26-.74-3.4 0-2.72 1.18-5.23 3.23-6.89 1.92-1.54 4.3-2.1 6.7-1.57 1.58.35 3.02 1.18 4.15 2.4.28.3.26.78-.04 1.06s-.78.26-1.06-.04c-.93-1-2.09-1.68-3.37-1.96-1.95-.42-3.88.03-5.43 1.28C6.3 5.55 5.33 7.63 5.33 9.9c0 .93.21 1.87.61 2.8a.751.751 0 1 1-1.38.6zM9.42 19.75c-.39 0-.94-.04-1.31-.42-.36-.37-.35-.84-.34-1.15v-.91c-.4-.28-.78-.6-1.14-.96a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0 .39.38.8.72 1.23 1 .21.14.35.38.35.63v1.37H14.62c.07 0 .12 0 .16-.01v-1.37c0-.26.13-.49.35-.63 2.47-1.58 4.37-5.08 3.23-8.71a.75.75 0 1 1 1.43-.45c1.31 4.18-.73 8.21-3.51 10.19v.77c.01.31.02.84-.39 1.26-.31.3-.73.45-1.28.45H9.42zM15.29 22.72c-2.16-.62-4.43-.62-6.59 0a.76.76 0 0 1-.93-.52c-.12-.4.12-.81.52-.93 2.42-.69 4.99-.69 7.41 0 .4.11.63.53.52.93-.09.34-.39.55-.72.55-.07 0-.14-.01-.21-.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineLampSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-lamp-slash.8818263589f29273796145482a676a2e.svg";
export { ForwardRef as ReactComponent };